import ActionType from './types';
import store from '../store/configureStore';
import {MAP_MIN_ZOOM_LEVEL, DEFAULT_MAP_POSITION} from '../constants';

export const handleZoomLevelChanged = (zoomLevel) => {
  return (dispatch) => {
    dispatch({
      type: ActionType.MAP_ZOOM_IN,
      zoomLevel
    });
  };
};

export const handlePositionChanged = (position) => {
  return (dispatch) => {
    dispatch({
      type: ActionType.UPDATE_MAP_POSITION,
      position
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/map.js